import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const ProgressWrapper = styled.div`
  flex: 1 1;
  padding-right: 0.625rem;
  display: inline-block;
`;

export const RatingsValue = styled.div`
  min-width: 7.5rem;
  display: flex;
`;

export const StarsBox = styled.div`
  display: inline-block;
`;

export const StarsValue = styled.div<{ newPdDesignEnabled: boolean }>`
  display: inline-block;
  width: 2.1875rem;
  padding-right: 0.625rem;

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          ${theme.typography.labelSmall400};
        `
      : css`
          font-size: 0.75rem;
        `}
`;

export const StarReviews = styled.div`
  margin-top: 1.5rem;

  @media (min-width: ${breakpoints.md}) {
    margin-top: 3.125rem;
  }
`;
